import isEmpty from "lodash/isEmpty";

import store from "../../store";
import {dbFeatureFilterProperties, dbFeatureRelatedFeaturesProperties, otherMissingProperties} from "./constants";
import {hasSubscriptionForRoom} from "../../misc/visualizerSwitchingFunctions";
import {getRoomNameToCompare} from "../../misc/categorySwitchingFunctions";


/**
 * Checks whether to show room feature as in visualizer in the navigation
 * @param feature {featureInterface}
 * @returns {featureInterface}
 */
export const setRoomNotInVisualizerProperty = (feature) => {
  const fabricatorSubscriptions = store.getState().fabricatorState.fabricatorSubscriptions;
  if (!feature || !feature.dbFeature || !feature.dbFeature.sharedFeatureName) {
    return feature
  }

  // const visType = getCommonVisualizerType();
  // if (name === visType) {
  //   feature.notAvailableInVisualizer = false;
  //   feature.dbFeature.unlocked = true;
  //   return feature
  // }
  if (!Array.isArray(fabricatorSubscriptions)) {
    return feature
  }
  const name = feature.dbFeature.sharedFeatureName.toLowerCase();
  const subscription = fabricatorSubscriptions.find(subscr => subscr.service.toLowerCase() === name)
    || hasSubscriptionForRoom(getRoomNameToCompare(feature));
  if (subscription) {
    feature.notAvailableInVisualizer = false;
    feature.dbFeature.unlocked = true;
    if (subscription.thumbnail) {
      feature.customThumbnail = subscription.thumbnail
    }
  }
  return feature
}

/**
 * updates existing dbFeature
 * @param dbFeature {dbFeatureInterface} // new
 * @param existingDbFeature {dbFeatureInterface} // old (existing)
 * @param layout {object} // layout
 */
export const updateExistingFeature = (dbFeature, existingDbFeature, layout) => {
  if (!existingDbFeature["relatedFeatureIds"] && Array.isArray(dbFeature["relatedFeatureIds"])) {
    existingDbFeature["relatedFeatureIds"] = dbFeature["relatedFeatureIds"];
  }
  // loadRelatedFeatures(dbFeature, layout);
  dbFeatureRelatedFeaturesProperties.forEach(property => {
    if (!existingDbFeature[property] && Array.isArray(dbFeature[property])) {
      existingDbFeature[property] = dbFeature[property];
      const parentGroups = layout.getFeatures(true);
      dbFeature[property].forEach(dbFeature => {
        layout.loadDbFeature(dbFeature, parentGroups)
      })
    }
  })
  if ((!Array.isArray(existingDbFeature.stonePricingId) || !existingDbFeature.stonePricingId.length || existingDbFeature.stonePricingId[0] === -1)
    && (Array.isArray(dbFeature.stonePricingId) && dbFeature.stonePricingId.length && dbFeature.stonePricingId[0] !== -1)) {
    existingDbFeature.stonePricingId = dbFeature.stonePricingId
  }
  // if (dbFeature.useCostBaseLogicApplied) { // always update
  existingDbFeature.cost = dbFeature.cost; // not sure about this one, but let it be, as it seems like the main response is not always correct
  existingDbFeature.price = dbFeature.price; // price sometimes comes as null in the main response, so we need to update it
  // }
  dbFeatureFilterProperties.forEach((key) => {
    if ((!existingDbFeature[key] || isEmpty(existingDbFeature[key])) && dbFeature[key] && !isEmpty(dbFeature[key])) {
      existingDbFeature[key] = dbFeature[key];
      dbFeature.wasUpdatedFromAnotherResponse = true; // to erase ._customDisplayName, because we need filters to create it again!
      existingDbFeature.wasUpdatedFromAnotherResponse = true; // to erase ._customDisplayName, because we need filters to create it again!
    }
  });
  otherMissingProperties.forEach((key) => {
    if ((!existingDbFeature[key] || isEmpty(existingDbFeature[key])) && dbFeature[key] && !isEmpty(dbFeature[key])) {
      existingDbFeature[key] = dbFeature[key];
    }
  });
  if (dbFeature.markUpString) {
    existingDbFeature.markUpString = dbFeature.markUpString;
    existingDbFeature.price = dbFeature.price;
    existingDbFeature.cost = dbFeature.cost;
    existingDbFeature.discount = dbFeature.discount;
    existingDbFeature.shippingCost = dbFeature.shippingCost;
  }
}


export const loadRelatedFeatures = (dbFeature, layout) => {
  if (!Array.isArray(dbFeature.relatedFeatureIds) || !dbFeature.relatedFeatureIds.length) {
    return
  }
  // console.log("loadRelatedFeatures!!", dbFeature);
  dbFeature.relatedFeatureIds.forEach(relFeatureId => {
    if (!dbFeature.relatedFeatures) {
      dbFeature.relatedFeatures = [];
    }
    if (dbFeature.relatedFeatures.some(relFeature => relFeature.id === relFeatureId)) {
      return // already loaded
    }
    let loadedDbFeature = null;
    Object.keys(layout.allDbFeatures).forEach(groupName => {
      for (let i = 0; i < layout.allDbFeatures[groupName].length; i++) {
        if (layout.allDbFeatures[groupName][i].id === relFeatureId) {
          loadedDbFeature = layout.allDbFeatures[groupName][i];
          break;
        }
      }
    })
    if (loadedDbFeature) {
      dbFeature.relatedFeatures.push(loadedDbFeature);
    } else {
      console.log("related feature wasn't loaded"); // it it fires - then something is wrong, we should load related before main features
    }
  })
  // console.log("dbFeature.relatedFeatures", dbFeature.relatedFeatures);
}
